import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

type RouteParams = Readonly<Partial<Record<string, string>>>;

/**
 * Keeps pre-v2 bookmarks and shared links alive after the /organization/* flattening.
 */
const LegacyRedirect: React.FC<{ to: (params: RouteParams) => string }> = ({ to }) => {
  const params = useParams();
  const { search, hash } = useLocation();

  return <Navigate to={`${to(params)}${search}${hash}`} replace />;
};

export default LegacyRedirect;
